// Profile-visit tracking (Top 8 Fans) isn't on the app backend. No-op for now.
const useProfileVisitTracker = () => {};

export default useProfileVisitTracker;
